import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { IconButton } from '../button/icon-button';
import { IconClose, IconInsertDriveFile } from '../icon';
import { List, ListItem } from '../list';
import { styled } from '../styled';
import { Typography } from '../typography';
import { getFileIcon } from './helpers';
const getFileProperties = (file) => {
    const { name, size, lastModified } = file;
    return `${name}-${size}-${lastModified}`;
};
const getFileUniqueId = (file) => {
    if ('preview' in file) {
        return `item-${getFileProperties(file)}`;
    }
    if (file.file) {
        return `item-${getFileProperties(file.file)}`;
    }
    return `item-${file.message}-${file.formattedSize}`;
};
const StyledList = styled(List)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
}));
const StyledListItem = styled(ListItem)(({ theme, $isError }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    ...($isError && {
        borderColor: theme.palette.error.main,
        backgroundColor: theme.palette.components?.alert?.error?.background
    })
}));
const FilePreviewItem = ({ file, onRemove }) => {
    const isFile = 'preview' in file;
    const fileName = isFile ? file.name : file.file?.name;
    const handleAvatarClick = () => {
        if (isFile && file.preview) {
            window.open(file.preview, '_blank');
        }
    };
    return (_jsx(StyledListItem, { "$isError": !isFile, secondaryAction: _jsx(IconButton, { edge: "end", "aria-label": "delete", onClick: onRemove, children: _jsx(IconClose, {}) }), avatar: {
            variant: 'square',
            src: isFile && file.type?.startsWith('image/')
                ? file.preview
                : undefined,
            size: 40,
            onClick: handleAvatarClick,
            sx: {
                cursor: isFile && file.preview ? 'pointer' : 'default'
            },
            children: !isFile || !file.type ? (_jsx(IconInsertDriveFile, {})) : (getFileIcon(file))
        }, primary: _jsx(Typography, { variant: "body2", color: "text.primary", fontWeight: 500, children: fileName }), secondary: _jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", color: "text.secondary", children: file.formattedSize }), !isFile && (_jsxs(_Fragment, { children: [' - ', _jsx(Typography, { component: "span", color: "error", children: file.message })] }))] }) }));
};
export const FilePreview = ({ files, errors, onRemoveItem }) => {
    if (files.length === 0 && errors.length === 0) {
        return null;
    }
    const allItems = [...files, ...errors];
    return (_jsx(StyledList, { children: allItems.map((item, index) => (_jsx(FilePreviewItem, { file: item, onRemove: () => onRemoveItem(index) }, getFileUniqueId(item)))) }));
};
